/**
 * Created by Gaplo917 on 6/9/2017.
 */
import * as PIXI from 'pixi.js'
import * as Rx from 'rxjs'
import TWEEN from "@tweenjs/tween.js"
import Image from "../../objects/Image";
import R from "../../config/R";
import * as Events from "../../Events";
import {AnimationUtils} from "../../AnimationUtils";
import * as _ from "lodash";
import CustomAnimatedSprite from "../../objects/CustomAnimatedSprite";

export class Indian extends PIXI.Container {
  constructor(x, y, resources, withKey = false){
    super()
    this.x = x
    this.y = y

    // create for ref
    this.indianWithKey = new CustomAnimatedSprite(0,0, resources, R.spines.indianWithKey)
    this.indianWihoutKey = new CustomAnimatedSprite(0,0, resources, R.spines.indian)

    this.indian = withKey
      ? this.indianWithKey
      : new CustomAnimatedSprite(0,0, resources, R.spines.indian)

    this.addChild(this.indian)

    this.normal()
  }

  normal(){
      this.indian.playAnimation(R.spines.indian.animations.animation, true)
  }

  happy(){
    this.removeChild(this.indian)
    this.addChild(this.indianWihoutKey)

    this.indianWihoutKey.playAnimation(R.spines.indian.animations.happy, true)
  }

  randomIntFromInterval(min,max) {
    return Math.floor(Math.random()*(max-min+1)+min);
  }
}



// WEBPACK FOOTER //
// ./src/game/characters/level2/Indian.js